import { validateInput } from "./PasswordValidationService";
import { isFullFormValid } from "../../util/Validators";

export const passwordResetValidationInitialState = {
    originalPasswordError: false,
    originalPasswordErrMsg: "",
    newPasswordError: false,
    newPasswordErrMsg: "",
    verifyNewPasswordError: false,
    verifyNewPasswordErrMsg: "",

    isFormValid: true
  }
  
  export const PasswordResetFormValidationReducer = (state, action) => {
      if (!action.payload){
        return state;
      }
      let isValid = false;
      switch (action.type) {
        case "VALIDATE_ORIGINALPASSWORD":
            let { originalPassword } = action.payload;
            let originalPasswordState = validateInput('originalPassword', originalPassword);
            isValid = !originalPasswordState.hasError;
            let origpwdErrMsg = originalPasswordState.error;
            return {
              ...state,
              ...({ originalPasswordError: !isValid, originalPasswordErrMsg: origpwdErrMsg, isFormValid:  isFullFormValid(state, 'originalPasswordError', !isValid)})
            }
        case "VALIDATE_NEWPASSWORD":
          let { newPassword } = action.payload;
          let newPasswordState = validateInput('newPassword', newPassword);
          isValid = !newPasswordState.hasError;
          let newPwdErrMsg = newPasswordState.error;
          return {
            ...state,
            ...({newPassword: newPassword, newPasswordError: !isValid, newPasswordErrMsg: newPwdErrMsg, isFormValid: isFullFormValid(state, 'newPasswordError', !isValid) })
          }
          case "VALIDATE_VERIFYNEWPASSWORD":
            let {verifyNewPassword, formData } = action.payload;
            let verifyNewPwdState = validateInput('verifyNewPassword', verifyNewPassword);
            isValid = !verifyNewPwdState.hasError;
            let verifyNewPwdErrMsg = verifyNewPwdState.error;

            if (isValid){
              if (formData && verifyNewPassword !== formData.newPassword){
                isValid = false;
                verifyNewPwdErrMsg = "New Password and Verification fields should match";
              }
            }

            return {
              ...state,
              ...({verifyNewPassword: {verifyNewPassword}, verifyNewPasswordError: !isValid, verifyNewPasswordErrMsg: verifyNewPwdErrMsg, isFormValid: isFullFormValid(state, 'verifyNewPasswordError', !isValid) })
            }



        default:
          return state
      }
    }
  
  
  
  